export const APP_NAME = 'identification_perseus';

export const ROLLOUTS = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 'lynxes_identification_core_reset_password_flow',
    LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT: 'lynxes_identification_illustration_right',
} as const;

export const EXPERIMENTS = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 4944,
    LYNXES_IDENTIFICATION_ILLUSTRATION_RIGHT: 4874,
    LYNXES_MODERN_HEADER: 4880,
    LYNXES_SEAMLESS_ONBOARDING_AND_ROUTING: 5010,
} as const;
